import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const ResultsEntry: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to analysis page since results entry is handled there
    navigate('/analysis', { replace: true });
  }, [navigate]);

  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      minHeight="400px"
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
        Redirection vers la page d'analyse...
      </Typography>
    </Box>
  );
};

export default ResultsEntry; 